import React, { useState, useEffect } from "react";
import { PlusIcon, MinusIcon } from "@src/stories/elements/Icons";

declare const window: Window &
  typeof globalThis & {
    theme: {
      filesURL: any;
    };
  };

export const CollectionFilters = ({ changeFilter, filters, selectedFilters, setSelectedFilters, totalResults, selectedFilterCounts, totalSelectedFilters, clearAllFilters, toggleFilterDrawer }) => {
  const [expandedSections, setExpandedSections] = useState<Record<string, boolean>>({});
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
      const initialFilters = Array.from(params.entries())
          .filter(([key]) => key.startsWith("filter."))
          .map(([key, value]) => `${key}=${value}`)
          .join("&");
        setSelectedFilters(initialFilters);
      }, []);
    
  const isFilterSelected = (filterField: string, value: any, low: number, high: number): boolean => {
    if (!selectedFilters) return false;
    
    const filtersArray = selectedFilters.split('&').filter(Boolean);
          console.log('Checking price filter for value:', value);
    if (filterField === "ss_price") {
      // Debug the value object

      const lowFilter = `filter.${filterField}.low`;
      const highFilter = `filter.${filterField}.high`;
      
      // Find the actual price values in filtersArray
      const lowFilterValue = filtersArray.find(f => f.startsWith(lowFilter))?.split('=')[1];
      const highFilterValue = filtersArray.find(f => f.startsWith(highFilter))?.split('=')[1];
      
      
      if (lowFilterValue && highFilterValue) {
        // Compare as strings since URL params are strings
        return String(low) === lowFilterValue && String(high) === highFilterValue;
      }
      return false;
    } else {
      const filterString = `filter.${filterField}=${value}`;
      return filtersArray.includes(filterString);
    }
  };

  const handleSelectFilter = (filterField: string, value: any) => {
    setSelectedFilters((prevFilters) => {
      let updatedFilters = prevFilters || "";
      let filtersArray = updatedFilters.split("&").filter(Boolean);
  
      if (filterField === "ss_price") {
        const lowFilter = `filter.${filterField}.low=${value.low}`;
        const highFilter = `filter.${filterField}.high=${value.high}`;
  
        const lowExists = filtersArray.includes(lowFilter);
        const highExists = filtersArray.includes(highFilter);
  
        if (lowExists && highExists) {
          filtersArray = filtersArray.filter(
            (filter) => filter !== lowFilter && filter !== highFilter
          );
        } else {
          filtersArray = filtersArray.filter(
            (filter) =>
              !filter.includes(`filter.${filterField}.low=`) &&
              !filter.includes(`filter.${filterField}.high=`)
          );

          if (value.low !== undefined && value.high !== undefined) {
            filtersArray.push(lowFilter);
            filtersArray.push(highFilter);
          }
        }
      } else {
        const newFilter = `filter.${filterField}=${value.value}`;
        const filterExists = filtersArray.includes(newFilter);
  
        if (filterExists) {
          filtersArray = filtersArray.filter((filter) => filter !== newFilter);
        } else {
          filtersArray.push(newFilter);
        }
      }

      updatedFilters = filtersArray.join("&");
      changeFilter(updatedFilters);
      return updatedFilters;
    });
  }

  const getColourImageUrl = (colour) => {
    const formattedColour = colour.toLowerCase().replace(/\s+/g, "-");
    const fileURL = `${window.theme.filesURL}${formattedColour}.png`;
    return fileURL;
  };

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    if (selectedFilters) {
      searchParams.set("filter", selectedFilters);
    } else {
      searchParams.delete("filter");
    }
  
    const queryString = searchParams.toString();
    const newUrl = `${window.location.pathname}${queryString ? `?${queryString}` : ''}`;
    
    window.history.pushState({}, "", newUrl);
  }, [selectedFilters]);



  const toggleSection = (sectionKey: string) => {
    setExpandedSections(prev => ({
      ...prev,
      [sectionKey]: !prev[sectionKey]
    }));
  };


  return (
    <div className="filter-container no-scrollbars">
      {/* Accordion Filter Sections */}
      <div className="overflow-auto no-scrollbars"
        style={{ height: "calc(100dvh - ( 48px + 89px))" }}
      >
        {filters && filters.map((filter, index) => (
          <div key={`filter-${index}`} className="py-[14px] w-[90%] lg:w-full px-2 lg:px-5 ">
            <button
              onClick={() => toggleSection(filter.field)}
              className="flex w-full justify-between items-center p-0 text-left font-medium h-7 min-h-7"
            >
              <div className="flex flex-row gap-2 items-center">
                <span className="b2--r !font-semibold normal-case">{filter.label}</span>
                { selectedFilterCounts[filter.field]  && 
                <span className="b3--lh20 normal-case font-[400]">{selectedFilterCounts[filter.field]} selected</span> }
              </div>
              <span className={`transform transition-transform p-2`}>
                {expandedSections[filter.field] ?    <MinusIcon type={'w-3 h-3'} /> : <PlusIcon type={'w-3 h-3'} /> }
              
              </span>
            </button>
            
            {expandedSections[filter.field] && (
              <div className="">
                {(
                  <div className="flex flex-col mt-[14px]">
                    {filter.values.map((option, optionIndex) => {
                        const showColor = filter.field == 'variant_colour';
                        const colorImage = option.value && getColourImageUrl(option.value);
                      return ( 
                        <label 
                          key={`option-${optionIndex}`}
                          className="flex items-center cursor-pointer group my-2"
                        >
                          <input
                            type="checkbox"
                            checked={isFilterSelected(filter.field, option.value, option?.low, option?.high)}
                            onChange={() => handleSelectFilter(filter.field, option)}
                            className="h-4 w-4 border-gray-300 rounded focus:ring-primary"
                          />
                          {showColor &&  (
                            colorImage ? (
                              <img
                                src={colorImage}
                                alt={option.label}
                                className="w-5 h-5 ml-3 rounded-full"
                                onError={(e) => {
                                  e.currentTarget.onerror = null;
                                  e.currentTarget.style.backgroundColor = 'transparent';
                                  e.currentTarget.style.border = '1px solid #E1E1E1';
                                  e.currentTarget.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'; // Transparent 1x1 pixel
                                }}
                              />
                            ) : (
                              <span className="w-5 h-5 mx-3 rounded-full bg-gray-200 block"></span>
                            ))  }
                          <span className="ml-3 b3--r ">
                            {option.label} ({option.count})
                          </span>
                        </label>
                      )
                      }
                    )}
                  </div>
                )}
              </div>
            )}
          </div>
        ))}
      </div>
      
      <div className=" flex flex-row">
        <button
              onClick={() => {
                clearAllFilters();
              }}
              className="b3--lh20 h-[44px] font-normal normal-case w-1/2 border border-primary"
            >
              {`Clear All (${ totalSelectedFilters})`}
        </button>
        <button 
          className="w-1/2 py-3 bg-primary h-[44px] b3--lh20 text-white shadow-sm hover:bg-primary-dark transition-colors normal-case"
          onClick={toggleFilterDrawer}
        >
          {`View (${totalResults})`}
        </button>
      </div>


    </div>
  );
};

export default CollectionFilters;